import Logo from './Logo';
import { EyeIcon, EyeOffIcon } from './Icons';
import useLogin from '../hooks/useLogin';

export default function Login({ onLogin, showToast }) {
  const { email, setEmail, password, setPassword, showPassword, setShowPassword, loading, handleSubmit } =
    useLogin({ onLogin, showToast });

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <Logo size="large" center />
          <p>Sign in to continue</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              className="form-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <div className="form-input-with-toggle">
              <input
                className="form-input"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="toggle-visibility"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                {showPassword ? <EyeOffIcon size={18} /> : <EyeIcon size={18} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
